import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import StatBoxSlim from "components/Stats/StatBoxSlim";

const useStyles = makeStyles((theme) =>
  createStyles({
    lblPercent: {
      marginTop: 32,
      flexGrow: 1,
      textAlign: "right",
      fontSize: 13,
    },
    tooltip: {
      position: "absolute",
      top: "8px",
      left: "50%",
      transform: "translateX(-50%)",
      padding: "5px 10px",
      borderRadius: "4px",
      fontSize: "14px",
      whiteSpace: "nowrap",
    },
    captionRight: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: 12,
      color: theme.palette.text.secondary,
    },
    captionNote: {
      whiteSpace: "nowrap",
    },
    summaryText: {
      whiteSpace: "nowrap",
      fontSize: 12,
      fontWeight: 500,
    },
  })
);

const PhotoShootAssetType = ({
  company,
  dataPhotoShootByAsset, // TEPCO
  dataPhotoShootByAssetHokuden, // HEPCO
}) => {
  const classes = useStyles();

  // ローディング判定（NTT踏襲：先頭の subType === 'loading'）
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // ---- どの配列を使うかを決定 ----
  useEffect(() => {
    const arrTepco = Array.isArray(dataPhotoShootByAsset) ? dataPhotoShootByAsset : [];
    const arrHkd = Array.isArray(dataPhotoShootByAssetHokuden) ? dataPhotoShootByAssetHokuden : [];

    // 会社指定があればそれを優先
    let chosen;
    if (company && /^(HOKUDEN|HEPCO)$/i.test(company)) {
      chosen = arrHkd;
    } else if (company && /^(NTT|TEPCO)$/i.test(company)) {
      chosen = arrTepco;
    } else {
      // 自動選択：非loadingかつ非空を優先
      const isLoad = (a) => a.length > 0 && a[0]?.subType === "loading";
      if (arrHkd.length && !isLoad(arrHkd)) chosen = arrHkd;
      else if (arrTepco.length && !isLoad(arrTepco)) chosen = arrTepco;
      else if (isLoad(arrHkd)) chosen = arrHkd;
      else chosen = arrTepco;
    }

    setIsLoading(chosen.length > 0 && chosen[0]?.subType === "loading");
    setRows(chosen);
  }, [company, dataPhotoShootByAsset, dataPhotoShootByAssetHokuden]);

  // データなし（loading ではない）
  if (!isLoading && rows.length === 0) {
    return <Typography variant="body2" color="textSecondary">データがありません</Typography>;
  }

  const total = !isLoading
    ? rows.reduce((sum, it) => sum + (Number(it.CNT) || 0), 0)
    : null;

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Grid container justifyContent="space-between" alignItems="center">
          {/* 左側：合計 */}
          <Typography variant="caption" className={classes.summaryText}>
            {isLoading ? "loading" : `合計：${total.toLocaleString()}`}
          </Typography>

          {/* 右側：注釈 */}
          <Typography variant="caption" className={classes.captionNote}>
            ※ すべてレビューOKの件数です
          </Typography>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={1}>
          {rows.map((item) => (
            <Grid key={item.subType} item xs={12} sm={6} md={3} lg={2}>
              <StatBoxSlim
                title={item.label ?? item.subType}
                value={isLoading ? "loading" : item.CNT ?? "-"}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

PhotoShootAssetType.propTypes = {
  company: PropTypes.string,
  dataPhotoShootByAsset: PropTypes.array,
  dataPhotoShootByAssetHokuden: PropTypes.array,
};

const mapStateToProps = (state) => ({
  dataPhotoShootByAsset: state.pictree.dataPhotoShootByAsset,
  dataPhotoShootByAssetHokuden: state.pictreeHokuden.dataPhotoShootByAsset,
});

export default connect(mapStateToProps)(
  withStyles(null, { withTheme: true })(PhotoShootAssetType)
);
